import { AppState } from '../rootReducer';

export const isLoading = (state: AppState) => state.reports.isLoading;
export const getReports = (state: AppState) => state.reports.all;
export const getTotal = (state: AppState) => state.reports.total;
export const getFilterOptions = (state: AppState) => state.reports.filterOptions;
